import r2wc from "@r2wc/react-to-web-component";

import { ProfilesBubble } from "@percy.ai/ui";

const ProfilesBubbleComponent = r2wc(ProfilesBubble, {
  props: {
    users: "json",
    backgroundColor: "string",
    textColor: "string",
    endpointUrl: "string",
    toAgentId: "number",
    toTeamId: "number",
    agentBrandedPage: "boolean",
    showCheckbox: "boolean",
    agentName: "string",
    brokerageName: "string",
    agentType: "string",
    workingWithAgent: "string",
  },
});

if (customElements) {
  customElements.define("profile-bubbles", ProfilesBubbleComponent);
}
